import React, { useState, useEffect } from 'react';
import './Calendar.css';

function generateTimeOptions() {
  const options = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 30) {
      const hh = String(h).padStart(2, '0');
      const mm = String(m).padStart(2, '0');
      const time = `${hh}:${mm}`;
      const ampm = h >= 12 ? 'PM' : 'AM';
      const h12 = h % 12 || 12;
      const label = `${h12}:${mm} ${ampm}`;
      options.push({ value: time, label });
    }
  }
  return options;
}

const TIME_OPTIONS = generateTimeOptions();

function toLocalDateInput(date) {
  if (!date) return '';
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}

export default function AddNoteModal({ open, onClose, onSave, defaultDate, initialData }) {
  const [title, setTitle] = useState('');
  const [date, setDate] = useState(toLocalDateInput(defaultDate || new Date()));
  const [startTime, setStartTime] = useState('09:00');
  const [endTime, setEndTime] = useState('11:00');
  const [notes, setNotes] = useState('');

  useEffect(() => {
    setDate(toLocalDateInput(defaultDate || new Date()));
  }, [defaultDate]);

  useEffect(() => {
    if (initialData) {
      setTitle(initialData.title || '');
      setDate(initialData.date ? initialData.date : toLocalDateInput(defaultDate || new Date()));
      setStartTime(initialData.start_time || '09:00');
      setEndTime(initialData.end_time || '11:00');
      setNotes(initialData.notes || '');
    } else if (!open) {
      setTitle(''); setStartTime('09:00'); setEndTime('11:00'); setNotes('');
    }
  }, [initialData, open, defaultDate]);

  if (!open) return null;

  function submit(e) {
    e.preventDefault();
    if (!title) return alert('Please enter a title');
    if (!date) return alert('Please select a date');
    const payload = { date, start_time: startTime, end_time: endTime, title, notes };
    onSave(payload, initialData?.id);
  }

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onClick={(ev) => { if (ev.target.classList.contains('modal-overlay')) onClose(); }}>
      <div className="modal-content">
        <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
        <h3>{initialData ? 'Edit Note' : 'Add Note'}</h3>
        <form onSubmit={submit} className="event-form">
          <div style={{display:'flex', gap: '8px', alignItems:'flex-end'}}>
            <div style={{flex:2}}>
              <label>Note</label><br />
              <input value={title} onChange={e => setTitle(e.target.value)} placeholder="Note title" />
            </div>
            <div style={{flex:1}}>
              <label>Date</label><br />
              <input type="date" value={date} onChange={e => setDate(e.target.value)} required />
            </div>
            <div style={{flex:0.9}}>
              <label>Start</label><br />
              <select value={startTime} onChange={e => setStartTime(e.target.value)} required>
                {TIME_OPTIONS.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
            <div style={{flex:0.9}}>
              <label>End</label><br />
              <select value={endTime} onChange={e => setEndTime(e.target.value)} required>
                {TIME_OPTIONS.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div style={{marginTop:8}}>
            <label>Notes</label><br />
            <textarea value={notes} onChange={e => setNotes(e.target.value)} rows={4} />
          </div>

          <div style={{marginTop:12, display:'flex', justifyContent:'space-between'}}>
            <div>
              <button type="submit">Save</button>
              <button type="button" onClick={onClose} style={{marginLeft:8}}>Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
